'use client';

import type TrailPageType from '@alltrails/amplitude/enums/TrailPageType';
import ReviewSummaryPackage from '@alltrails/reviews/components/ReviewSummary/ReviewSummary';
import type { Review } from '@alltrails/types/Review';
import type { TrailId } from '@alltrails/types/TrailId';
import { useReviewSummaryContext } from '@/contexts/ReviewSummaryContext';
import { REVIEWS_SECTION_ID } from '@/utils/constants';

type ReviewSummaryProps = {
  trailId: TrailId;
  shuffledReviews?: Review[];
  isAdmin?: boolean;
  shouldExpand?: boolean;
  isInline?: boolean;
  avgRating?: number;
  trailPageType: TrailPageType;
};

const onShowAllReviewsClick = () => {
  const reviewSection = document.getElementById(REVIEWS_SECTION_ID);
  if (reviewSection) {
    reviewSection.focus();
    reviewSection.scrollIntoView({ behavior: 'smooth' });
  }
};

const ReviewSummary = (props: ReviewSummaryProps) => {
  const { isLoading, hideReviewSummary, reviewSummary, onToggleHideReviewSummary } = useReviewSummaryContext();

  return (
    <ReviewSummaryPackage
      {...props}
      reviewSummary={reviewSummary}
      hideReviewSummary={hideReviewSummary}
      isLoading={isLoading}
      onToggleHideReviewSummary={onToggleHideReviewSummary}
      onShowAllReviewsClick={onShowAllReviewsClick}
    />
  );
};

export default ReviewSummary;
